import { Dispatch } from 'redux'
import { ShortcutActionType } from "../action-types/shorcutTypes"
import { Action } from '../actions/shortcutActions'

export const listShortcuts = (shortcuts: string[]) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ShortcutActionType.LIST,
            payload: shortcuts
        })
    }
}

export const addShortcut = (shortcut: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ShortcutActionType.ADD,
            payload: shortcut
        })
    }
}

export const removeShortcut = (shortcut: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ShortcutActionType.REMOVE,
            payload: shortcut
        })
    }
}